import firebase from "firebase/compat/app";

export const applyActionCode = async (code: string): Promise<void> => {
  return await firebase.auth().applyActionCode(code);
};
